import React from 'react'

const Manual_buscar_clientes_registrados_clau_invu = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Cómo buscar clientes registrados de Clau en InvuPOS
        </h2>
        <iframe
          src="https://scribehow.com/embed/Como_buscar_clientes_Registrados_de_clau_en_InvuPOS__55GrewiFTnWeueH9tXJfkA?as=scrollable"
          className="scribe-iframe-general-72"
          width="100%"
          height="4200"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_buscar_clientes_registrados_clau_invu
